import { type FC } from 'react';
import { type FacilitiesIconProps } from './types';

const Parking: FC<FacilitiesIconProps> = ({ width, height, fill }) => (
  <svg
    width={width || '65'}
    height={height || '65'}
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.025 41.365H29.125V23.725H33.895C36.685 23.725 38.935 25.975 38.935 28.765C38.935 31.555 36.685 33.805 33.895 33.805H30.025V41.365V41.365ZM30.025 32.905H33.895C36.19 32.905 38.035 31.06 38.035 28.765C38.035 26.47 36.19 24.625 33.895 24.625H30.025V32.905V32.905Z"
      fill={fill || '#505050'}
    />
    <path
      d="M32.9049 47.395C24.3549 47.395 17.3799 40.42 17.3799 31.87C17.3799 23.32 24.3549 16.345 32.9049 16.345C41.4549 16.345 48.4299 23.32 48.4299 31.87C48.4299 40.42 41.4549 47.395 32.9049 47.395ZM32.9049 17.245C24.8499 17.245 18.2799 23.815 18.2799 31.87C18.2799 39.925 24.8499 46.495 32.9049 46.495C40.9599 46.495 47.5299 39.925 47.5299 31.87C47.5299 23.815 40.9599 17.245 32.9049 17.245Z"
      fill={fill || '#505050'}
    />
  </svg>
);

export default Parking;
